import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useController } from '@rest-hooks/react';

import PublicLayout from 'components/layouts/Public'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import FormSection from 'ui/FormSection';

import PasswordResetResource from 'resources/user/PasswordResetResource';
import StatusModal from 'components/StatusModal';
import { t } from 'i18n/index';
import {
  clearPendingOrgSignup,
  getPendingOrgSignup,
} from 'utils/pendingOrgSignup';

const forgotPassword = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [pendingOrgSignup, setPendingOrgSignupState] = useState(() => getPendingOrgSignup());
  const [email, setEmail] = useState(() => (getPendingOrgSignup()?.email || ''));
  const { fetch } = useController();

  const handleEmailChange = (event) => {
    const next = event.target.value;
    setEmail(next);
    if (pendingOrgSignup && next.trim().toLowerCase() !== pendingOrgSignup.email.trim().toLowerCase()) {
      clearPendingOrgSignup();
      setPendingOrgSignupState(null);
    }
  };

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    setLoading(false);
  };

  const handleValidation = (e) => {
    if (e.target.email.value === ""){
      setError(t('account:forgotPassword:errorEmailMissing'));
      handleOpenErrorModal();
      throw '';
    }
  };

  const handleLogin = useCallback(
    async e => {
      e.preventDefault();
      handleValidation(e);
      try {
        setLoading(true);
        await fetch(PasswordResetResource.create(), new FormData(e.target));
        setStep(2);
      } catch (error) {
        setError(error.message);
        handleOpenErrorModal();
      }
    },
    [fetch],
  );

  return (
    <PublicLayout isLogin={true} >
        <FormSection slim>
          <div className="account-form-page">
          <div className="form-title">{t('account:common:forgotPasswordAndResetPasswordPageTitle')}</div>
          { pendingOrgSignup
            ? <p>{t('account:forgotPassword:resumingOrgSignupInstructions', { title: pendingOrgSignup.title })}</p>
            : <p>{t('account:common:forgotPasswordAndResetPasswordPageDescription')}</p>
          }

          { step === 1 &&
          <form onSubmit={ handleLogin } >
            <TextField
              label={t('literal:email')}
              name="email"
              color="warning"
              value={email}
              onChange={handleEmailChange}
              fullWidth
              margin="normal">
            </TextField>
            <Button type='submit'
                    disabled={loading}
                    fullWidth
                    variant="contained"
                    color="primary">
              {loading
                ? t('literal:sending')
                : t('account:forgotPassword:requestInstructions')
              }
            </Button>
          </form>
          }

          { step === 2 &&
            <p>{t('account:forgotPassword:resetInstructions')}</p>
          }

          { error && <StatusModal message={ error } open ={ openErrorModal } onClose={ handleCloseErrorModal }/>}
          </div>
        </FormSection>
    </PublicLayout>
  );
};

forgotPassword.propTypes = {
  history: PropTypes.object,
}

export default forgotPassword;
